import { NavLink } from "react-router-dom";
import ziplogyxLogo from "../assets/images/Labh Logo.png";
import maskGroup from "../assets/images/background-image.jpg";
import "./Header.css";
import React, { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="w-full fixed top-0 left-0 z-50 bg-black h-[113px] md:h-[113px]">
      {/* Background with blended image */}
      <div
        className="w-full h-full"
        style={{
          backgroundImage: `url(${maskGroup})`,
          backgroundColor: "#93A7AA",
          backgroundBlendMode: "overlay",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex items-center justify-between px-4 md:px-8 h-full max-w-[1440px] mx-auto">
          {/* Logo */}
          <a href="/">
            <img
              src={ziplogyxLogo}
              alt="Ziplogyx Logo"
              className="w-[180px] max-h-[46px] z-10"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-10">
              {[
                { name: "Home", path: "/" },
                { name: "Services", path: "/service" },
                { name: "About", path: "/about" },
                { name: "Solutions", path: "/solution" },
              ].map(({ name, path }) => (
                <NavLink
                  key={name}
                  to={path}
                  className={({ isActive }) =>
                    `text-center text-[20px] font-medium relative transition-colors duration-300 ${
                      isActive
                        ? "text-[#5bc0fe]"
                        : "text-white hover:text-[#5bc0fe]"
                    }`
                  }
                >
                  {name}
                </NavLink>
              ))}
            </div>

            <button
              onClick={() => (window.location.href = "/Contact")}
              style={{ borderRadius: "20px" }}
              className="bg-white px-[24px] py-[6px] w-[140px] h-[48px] flex items-center justify-center shadow-[4px_4px_0px_rgb(51,51,51)] hover:bg-[#5bc0fe] transition-colors duration-300 ml-6"
            >
              <span className="text-[#5bc0fe] text-[17px] font-medium hover:text-black">
                Contact Us
              </span>
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={toggleMenu} className="text-white text-3xl">
              {isMenuOpen ? <HiX /> : <HiMenu />}
            </button>
          </div>
        </div>

        {/* Mobile Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden bg-black bg-opacity-95 absolute top-[113px] left-0 w-full z-40 flex flex-col items-center py-6 gap-4">
            {[
              { name: "Home", path: "/" },
              { name: "Services", path: "/service" },
              { name: "About", path: "/about" },
              { name: "Solutions", path: "/solution" },
            ].map(({ name, path }) => (
              <NavLink
                key={name}
                to={path}
                onClick={closeMenu}
                className={({ isActive }) =>
                  `text-[20px] font-medium transition-colors duration-300 ${
                    isActive ? "text-[#5bc0fe]" : "text-white"
                  }`
                }
              >
                {name}
              </NavLink>
            ))}
            <button
              onClick={() => {
                closeMenu();
                window.location.href = "/Contact";
              }}
              className="bg-white text-[#5bc0fe] px-6 py-2 rounded-full mt-2 hover:bg-[#5bc0fe] hover:text-white transition"
            >
              Contact Us
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
